<script>
	import { onMount } from "svelte";
	import { FETCHING, FETCHED, NOT_FETCHING } from "../config/const.js";
	import { jwt } from "../stores/jwtstore";
	import config from "../config/config.json";
	import {
		Grid,
		Row,
		Column,
		TextInput,
		PasswordInput,
		Button,
		Loading,
		InlineNotification,
	} from "carbon-components-svelte";
	import Login32 from "carbon-icons-svelte/lib/Login32/Login32.svelte";

	const {
		root,
		endpoints: { gettoken },
	} = config;

	let query = {};

	let errors = {
		password: {
			isset: false,
		},
		username: {
			isset: false,
		},
	};

	let jwtquerypromise;
	let jwtQueryStatus = NOT_FETCHING;

	const formsubmit = (event) => {
		errors = Object.keys(errors).reduce((acc, val) => {
			return { ...acc, [val]: { isset: false } };
		}, {});
		jwtquerypromise = request();
	};

	const request = async () => {
		const url = "http://" + root + gettoken;

		jwtQueryStatus = FETCHING;

		try {
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify(query),
			});

			const body = await response.json();

			if (!response.ok) {
				if (body.type === "invalid" || body.type === "missing") {
					errors[body.field].isset = true;
					errors[body.field].description = body.description;
					throw new Error("Requête invalide");
				}
				if (body.error.type === "QUERY") {
					if (body.error.code === "loginerror") {
						throw new Error("Couple login / mot de passe invalide");
					}
				}
				throw new Error("Erreur inconnue");
			}

			jwtQueryStatus = FETCHED;
			localStorage.setItem("jwt", body.jwt);
			jwt.set(body.jwt);
			console.log(localStorage.getItem("jwt"));
			return body;
		} catch (e) {
			jwtQueryStatus = FETCHED;
			if (e.name === "TypeError") {
				throw new Error("Impossible de contacter le serveur");
			}
			// Dans le cas d'une erreur 500
			throw new Error(e.message);
		}
	};
</script>

<Grid fullWidth>
	<form
		class="BookingForm"
		name="entriesform"
		on:submit|preventDefault={formsubmit}
	>
		<!-- TODO => trouver un moyen de faire en sorte que firefox se rappelle des logins -->
		<Row>
			<Column
				sm={{ span: 4, offset: 0 }}
				md={{ span: 6, offset: 1 }}
				lg={{ span: 8, offset: 4 }}
				xlg={{ span: 8, offset: 4 }}
				max={{ span: 8, offset: 4 }}
			>
				<TextInput
					bind:invalid={errors.username.isset}
					invalidText="La valeur entrée est invalide"
					helperText="Chiffres, lettres ou caractères spéciaux (sauf en première position), 5 à 25 caractères"
					id="login-username-textinput"
					name="username"
					labelText="Nom d'utilisateur"
					bind:value={query.username}
				/>
			</Column>
		</Row>
		<Row>
			<Column
				sm={{ span: 4, offset: 0 }}
				md={{ span: 8, offset: 0 }}
				lg={{ span: 8, offset: 4 }}
				xlg={{ span: 8, offset: 4 }}
				max={{ span: 8, offset: 4 }}
			>
				<PasswordInput
					bind:invalid={errors.password.isset}
					invalidText="La valeur entrée est invalide"
					helperText="Chiffres, lettres ou caractères spéciaux (sauf en première position), 5 à 25 caractères"
					hidePasswordLabel="Cacher le mot de passe"
					showPasswordLabel="Voir le mot de passe"
					id="login-password-textinput"
					labelText="Mot de passe"
					bind:value={query.password}
				/>
			</Column>
		</Row>
		<Row padding>
			<Column
				align="center"
				sm={{ span: 4, offset: 0 }}
				md={{ span: 8, offset: 0 }}
				lg={{ span: 8, offset: 4 }}
				xlg={{ span: 8, offset: 4 }}
				max={{ span: 8, offset: 4 }}
			>
				<Button
					kind="primary"
					type="submit"
					bind:value={query.username}
					icon={Login32}>Login</Button
				>
			</Column>
		</Row>
	</form>
	{#if jwtQueryStatus != NOT_FETCHING}
		<Row padding>
			<Column
				align="center"
				sm={{ span: 4, offset: 0 }}
				md={{ span: 4, offset: 2 }}
				lg={{ span: 8, offset: 4 }}
				xlg={{ span: 8, offset: 4 }}
				max={{ span: 8, offset: 4 }}
			>
				{#await jwtquerypromise}
					<Loading
						description="Active loading indicator"
						withOverlay={false}
					/>
				{:then queryRes}
					<div class="BookingRes">"OK"</div>
				{:catch error}
					<InlineNotification
						kind="error"
						subtitle={error.message}
						title="Erreur"
						hideCloseButton
					/>
				{/await}
			</Column>
		</Row>
	{/if}
</Grid>
<!-- </div> -->
